import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ArrowBack } from '@mui/icons-material';
import { Button } from '@mui/material';

import urls from '@routes/urls';

import './style.scss';

const BackToInquiriesButton: FC = () => {
  const { t } = useTranslation();

  return (
    <Button
      className="back-to-inquiries-button"
      variant="text"
      component={Link}
      to={urls.inquiries}
    >
      <ArrowBack />
      <span className="back-to-inquiries-button__text">
        {t('dietarySupplementInquiry.backToAllInquiries')}
      </span>
    </Button>
  );
};

export default BackToInquiriesButton;
